const LEVEL_THRESHOLDS = [
    { thresh: 90, desc: "Very Easy to Read (5th Grade)"},
    { thresh: 80, desc: "Easy to Read (6th Grade)"},
    { thresh: 70, desc: "Fairly Easy to Read (7th Grade)"},
    { thresh: 60, desc: "Plain English (8th and 9th Grade)"},
    { thresh: 50, desc: "Fairly Difficult to Read (10th and 12th Grade)"},
    { thresh: 30, desc: "Difficult to Read (College)"},
    { thresh: 10, desc: "Very Difficult to Read (College Graduates)"},
    { thresh: -200, desc: "Extremely Difficult to Read"}
];

export { LEVEL_THRESHOLDS };